var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/header/search-close.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_extra_small") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_small") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_medium")) {
output += "\n\n    <svg class=\"c-site-search__close-svg-mobile\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\"><defs><style>.c-site-search__close-svg-mobile--circle{fill:#f2f0eb;}.c-site-search__close-svg-mobile--line{fill:none;stroke:#5c5c5f;stroke-miterlimit:10;}</style></defs><title>AN Close Search Icon</title><g><g><circle class=\"c-site-search__close-svg-mobile--circle\" cx=\"9\" cy=\"9\" r=\"9\"></circle><line class=\"c-site-search__close-svg-mobile--line\" x1=\"5.25\" y1=\"5.25\" x2=\"12.75\" y2=\"12.75\"/><line class=\"c-site-search__close-svg-mobile--line\" x1=\"12.75\" y1=\"5.25\" x2=\"5.25\" y2=\"12.75\"/></g></g></svg>\n\n";
;
}
else {
output += "\n\n    <svg class=\"c-site-search__close-svg\" xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" x=\"0\" y=\"0\" viewBox=\"0 0 10 10\" xml:space=\"preserve\" enable-background=\"new 0 0 10 10\"><polygon class=\"st0\" points=\"10 9.5 5.5 5 10 0.5 9.5 0 5 4.5 0.5 0 0 0.5 4.5 5 0 9.5 0.5 10 5 5.5 9.5 10 \"/></svg>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/header/search-close.j2"] , dependencies)